import React from 'react';
import Button from '../common/Button';
import { URLS } from '../../data/constants';
import './CTA.css';

const CTA = () => {
  return (
    <section className="cta" id="conversar">
      <div className="wrap">
        <h2>Quer ser o próximo case?</h2>
        <p>
          O primeiro passo é uma conversa. 30 minutos para entender o que está
          acontecendo na sua empresa, e o que pode mudar. Sem compromisso.
        </p>
        <Button href={URLS.whatsapp}>Quero entender meus números</Button>
        <small>
          Atendemos um número limitado de empresas por vez para garantir a
          qualidade do acompanhamento.
        </small>
      </div>
    </section>
  );
};

export default CTA;
